var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"mb-5":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.showDetails)?_c('wallets-details',{attrs:{"wallet":_vm.wallet}}):_c('div',[_vm._v(" This user don't have wallets! ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }